import {UI} from "../../../../stem-core/src/ui/UIBase";

import {BasePanelPage} from "../../PanelPage";
import {AuthFlowPanel} from "../../../website/unauthenticated/slides/AuthFlowPanel.jsx";


export class AuthPanelPage extends BasePanelPage {
    getFlowOptions() {}

    render() {
        return <AuthFlowPanel {...this.getFlowOptions()} />
    }
}
